import { render, staticRenderFns } from "./seller.vue?vue&type=template&id=250c61cf&scoped=true&"
import script from "./seller.vue?vue&type=script&lang=js&"
export * from "./seller.vue?vue&type=script&lang=js&"
import style0 from "./seller.vue?vue&type=style&index=0&id=250c61cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250c61cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VFlex,VLayout,VNavigationDrawer,VTab,VTabs})
